import {fetchPrizesFailed, fetchPrizesSuccess} from 'modules/actions';
import {Api} from 'modules/utils';
import {call, put} from 'typed-redux-saga';


export const fetchPrizesSaga = function* () {
	try {
		const response = yield* call(Api.JSON.prize);
		yield* put(fetchPrizesSuccess(response));
	} catch (e: any) {
		yield* put(fetchPrizesFailed());
	}
};
